/**
 * Proxy Ops → painel (/api/ia/usuarios*) via sessão CRM.
 * Contrato igual ao phone.html do tenant original.
 */
const BASE = '/ops-api';

const tokenDe = user => user?.access_token || user?.accessToken || '';

const chamar = async (method, path, user, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      api_access_token: tokenDe(user),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(
      data.error || data.erro || data.mensagem || data.message || `HTTP ${res.status}`
    );
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
};

const accPath = (accountId, rest = '') =>
  `/accounts/${accountId}/usuarios${rest}`;

export const listUsuarios = (accountId, user) =>
  chamar('GET', accPath(accountId), user);

export const listAbas = (accountId, user) =>
  chamar('GET', accPath(accountId, '/abas'), user);

export const listDepartamentos = (accountId, user) =>
  chamar('GET', accPath(accountId, '/departamentos'), user);

export const createUsuario = (accountId, user, payload) =>
  chamar('POST', accPath(accountId), user, payload);

export const updateUsuario = (accountId, user, id, payload) =>
  chamar('PATCH', accPath(accountId, `/${id}`), user, payload);

export const deleteUsuario = (accountId, user, id) =>
  chamar('DELETE', accPath(accountId, `/${id}`), user);

export const credenciaisUsuario = (accountId, user, id) =>
  chamar('GET', accPath(accountId, `/${id}/credenciais`), user);
